import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "../../../../../assets/icons/closeIcon.svg";
import plusCircle from "../../../../../assets/icons/plusCircle.svg";
import minusCircle from "../../../../../assets/icons/minusCircle.svg";
import { SearchInputComponent } from "../../../../../common/components";
import Avatar from "@mui/material/Avatar";
import "./company-dashboard-initiative-drawer-side-bar.scss";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

export interface OwnerRoleOption {
  role: string;
}

const CompanyDashboardInitiativeDrawerSideBarRolePopup: any = (props: any) => {
  const {
    isShowEditRole,
    setIsShowEditRole,
    onSearch,
    Roles,
    selectedRole,
    handleRemoveRole,
    handleAddRole,
    setSelectedAddedRole,
    handleCreateInitiative,
    payloadData,
    setSelectedAddedDepartment,
    setSelectedDepartment,
    departRoles,
    setSelectedRole,
    selectedAddedDepartment
  } = props;
  const [Role, setRole] = useState(Roles);
  const stringAvatar = (name: string) => {
    return {
      sx: {
        bgcolor: "#403c6f",
      },
      children: `${name?.split(" ")?.[0]?.[0]}${name?.split(" ")?.[1]?.[0]}`,
    };
  };
  useEffect(() => {
    setRole(Roles);
  }, [Roles]);

  const validationSchema = () =>
    Yup.object({
      selectedOption: Yup.array()
        .min(1, "At least one Role is required")
        .required("Role is required"),
    }).shape({});

  const updateSetSelectedRole = (event: any, newValue: any, role: any) => {
    setSelectedRole(
      selectedRole?.map((dept: any) => {
        if (dept?.id === role?.id) {
          return {
            ...dept,
            role: newValue?.role || "Owner",
          };
        }
        return dept;
      }),
    );
  };
  const slotsPaperRole = (props: any) => {
    return (
      <div
        {...props}
        style={{
          backgroundColor: "#fff",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        {props.children}
      </div>
    );
  };

  const handleSortItem = () => {
    const sortedRoles = [...selectedRole?.sort((a: any, b: any) => a?.name?.localeCompare(b?.name)) || [], ...Role?.filter((role: any) => !selectedRole.some((selected: any) => selected?.id === role?.id)) || []];
    setRole(sortedRoles);
  }; 

  useEffect(() => {
    handleSortItem();
  }, [selectedRole]);
  return (
    <Dialog
      open={isShowEditRole}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`company-dashboard-initiative-drawer-side-bar-role-popup `}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        setIsShowEditRole(false);
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <div className="header-wrapper">
          <div className="header-wrapper-text">Role</div>
          <div className="image-wrapper">
            <button
              style={{
                border: "none",
                background: "none",
              }}
              onClick={() => {
                setIsShowEditRole(false);
              }}
            >
              <img
                alt="Close"
                src={CloseIcon}
                className="close-icon"
                style={{ cursor: "pointer" }}
              />
            </button>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Formik
            initialValues={{
              selectedOption: selectedRole,
            }}
            validationSchema={validationSchema}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={() => {
              setSelectedAddedRole(selectedRole);
              setSelectedAddedDepartment(departRoles);
              setSelectedDepartment(departRoles);
              setIsShowEditRole(false);
              handleCreateInitiative(setIsShowEditRole, {
                ...payloadData,
                owners: [
                  ...(selectedRole?.length
                    ? selectedRole?.map((role: any) => {
                        return {
                          ownerId: role?.id,
                          role: role?.role || "Owner",
                          isDepartmentOwner: selectedAddedDepartment?.some((dept: any) => dept?.id === role?.departmentId) || false,
                        };
                      }) || []
                    : []),
                ],
              });
            }}
          >
            {({ errors }) => (
              <Form>
                <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-section">
                  <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-search">
                    <SearchInputComponent
                      placeholder="Search Roles"
                      onSearch={onSearch}
                      isReset={false}
                      ref={null}
                    />
                  </div>
                  <div className="error-message">
                    {typeof errors?.selectedOption === "string" ? (
                      <div className="error-message">
                        {errors?.selectedOption}
                      </div>
                    ) : null}
                  </div>
                  <OverlayScrollbarsComponent
                    className="company-dashboard-initiative-drawer-side-bar-content-role-details"
                    options={{
                      scrollbars: {
                        theme: "os-theme-dark",
                        autoHide: "scroll",
                        autoHideDelay: 400,
                      },
                    }}
                  >
                    {Role.length > 0 ? (
                      <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-roles">
                        {Role.map((role: any, index: number) => (
                          <div
                            className={`company-dashboard-initiative-drawer-side-bar-content-roles-edit ${selectedRole?.find((dept: any) => dept?.id === role?.id) ? "roles-edit-selected" : ""}`}
                            key={index + 1}
                          >
                            <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-content">
                              <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-content-right">
                                <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-content-right-image">
                                    <Avatar {...stringAvatar(role?.name)} />   
                                </div>
                                <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-content-right-label">
                                  {role?.name}
                                </div>
                              </div>
                              <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-content-left">
                                <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-content-left-label">
                                  {selectedRole?.find(
                                    (dept: any) => dept?.id === role?.id,
                                  ) ? (
                                    <Autocomplete<OwnerRoleOption>
                                      value={{
                                        role:
                                          selectedRole?.find(
                                            (dept: any) =>
                                              dept?.id === role?.id,
                                          )?.role || null,
                                      }}
                                      onChange={(event, newValue) =>
                                        updateSetSelectedRole(
                                          event,
                                          newValue,
                                          role,
                                        )
                                      }
                                      options={[
                                        {
                                          role: "Owner",
                                        },
                                        {
                                          role: "PM",
                                        },
                                      ]}
                                      getOptionLabel={(option) => option.role}
                                      isOptionEqualToValue={(option, value) =>
                                        option.role === value.role
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label=""
                                          placeholder="Select Status"
                                        />
                                      )}
                                      sx={{
                                        "& .MuiAutocomplete-option": {
                                          fontSize: "14px",
                                          fontFamily: "Manrope, sans-serif",
                                        },
                                      }}
                                      slots={{
                                        paper: (props) => slotsPaperRole(props),
                                      }}
                                      slotProps={{
                                        popper: {
                                          sx: {
                                            "& .MuiAutocomplete-option": {
                                              fontSize: "14px",
                                              fontFamily: "Manrope, sans-serif",
                                            },
                                          },
                                        },
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-content-left-img">
                                  {selectedRole?.find(
                                    (dept: any) => dept?.id === role?.id,
                                  ) ? (
                                    <button
                                      style={{
                                        border: "none",
                                        background: "none",
                                        padding: 0,
                                      }}
                                      type="button"
                                      onClick={() => handleRemoveRole(role.id)}
                                    >
                                      <img
                                        src={minusCircle}
                                        alt="remove"
                                        className="remove-role"
                                      />
                                    </button>
                                  ) : (
                                    <button
                                      style={{
                                        border: "none",
                                        background: "none",
                                        padding: 0,
                                      }}
                                      type="button"
                                      onClick={() => handleAddRole(role)}
                                    >
                                      <img
                                        src={plusCircle}
                                        alt="add"
                                        className="add-role"
                                      />
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="no-data-found">No Employees Found</div>
                    )}
                  </OverlayScrollbarsComponent>
                  <div className="company-dashboard-initiative-drawer-side-bar-content-role-edit-action">
                    <button
                      className="company-dashboard-initiative-drawer-side-bar-content-role-edit-action-cancel"
                      onClick={() => setIsShowEditRole(false)}
                      type="button"
                    >
                      Cancel
                    </button>
                    <button
                      className="company-dashboard-initiative-drawer-side-bar-content-role-edit-action-save"
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarRolePopup;
